<script lang="ts" setup>
// What a campaign or a flow brought in: paid orders placed through its mails' shop links
// (get_mail_sales). Nothing until there is something; the revenue only for whoever sees payments.
import type { Database } from '~~/types/supabase';
const { t } = useI18n();
const props = defineProps<{ campaignId?: string; flowId?: string }>();
const supabase = useSupabaseClient<Database>();
const userStore = useUserStore();
const sales = ref<{ orders: number; revenue: number } | null>(null);

watch(() => [props.campaignId, props.flowId], async () => {
  const { data, error } = await supabase.rpc('get_mail_sales', { p_campaign_id: props.campaignId, p_flow_id: props.flowId });
  if (error) console.error('get_mail_sales', error);
  sales.value = data?.[0] ?? null;
}, { immediate: true });
</script>

<template>
  <p v-if="sales?.orders" class="m-0 text-sm tabular-nums">
    <span class="font-medium">{{ t('mail_sales', { n: sales.orders }, sales.orders) }}</span>
    <template v-if="userStore.hasRight('payments.read')"> · <ValutaView :amount="sales.revenue" /></template>
  </p>
</template>
